/**
 * Auto-découvert par `apps/web/src/routes/modules.ts` via :
 *   import.meta.glob('../../../modules/*\/web/route.tsx', { eager: true })
 */
import { lazy, Suspense, type ReactNode } from 'react';

const PilotageAchatsPage = lazy(() => import('./pages/PilotageAchats'));

function LoadingFallback(): ReactNode {
  return (
    <div className="p-6 text-sm text-slate-500" role="status" aria-live="polite">
      Chargement du module Pilotage achats…
    </div>
  );
}

const route = {
  path: 'pilotage-achats',
  label: 'Pilotage achats',
  icon: 'gauge',
  element: (
    <Suspense fallback={<LoadingFallback />}>
      <PilotageAchatsPage />
    </Suspense>
  ),
};

export default route;
